/* Naguirre — gaveta rápida (03/10/2026).
   Antes: ao tocar "Adicionar ao Carrinho" na página do produto, o tema fazia 3 idas ao servidor,
   uma esperando a outra — POST /cart/add.js → GET /cart.js → GET /cart?view=ajax_side_cart — e a
   gaveta abria vazia até a 3ª voltar (medido em 03/10 na loja: ~1,8–2,75 s até o produto aparecer).
   Agora o próprio POST pede a seção "ng-gaveta" (Section Rendering API): a resposta já traz o HTML
   da gaveta e o JSON do carrinho, os dois do mesmo instante, e as leituras que o tema faz logo em
   seguida são respondidas com isso (medido: ~1,2–1,5 s, e a gaveta já abre com o produto).
   Onde vale: POST /cart/add.js feito por fetch com FormData (sem items[]) quando a gaveta vai abrir
   (quick_cart) — na prática, o botão da página do produto (<product-form> → actionAddToCart2).
   Cards, compra rápida, kit, editar carrinho e a página /cart seguem exatamente como antes.
   Regras de segurança:
   - só guarda a resposta se o POST correu sozinho: nenhuma outra mudança de carrinho em voo quando
     ele saiu e nenhuma enviada depois (fetch, jQuery/XHR de app, GraphQL com mutation, /discount/);
   - a resposta guardada vale 1,5 s; o HTML é servido uma vez e o carrinho uma vez (mais as leituras
     feitas enquanto a gaveta guardada é desenhada, como a barra de frete grátis);
   - só leituras GET assíncronas do jQuery, sem outros parâmetros, são atendidas; o resto vai ao
     servidor como antes;
   - se a resposta não trouxer a seção (erro, esgotado, 429), nada é guardado;
   - o POST continua sendo um POST real, enviado uma única vez: os rastreadores veem o mesmo
     "adicionou ao carrinho" (medido: disparos Meta/GA4/Ledger idênticos ao tema sem o atalho).
   O carrinho servido é o {{ cart | json }} do Liquid: mesmos itens, quantidades e totais do /cart.js,
   sem token, discount_codes, presentment_price, quantity_rule e has_components (que nenhum leitor
   dessas leituras usa; ver sections/ng-gaveta.liquid). */
(function () {
  'use strict';

  var $ = window.jQuery;
  if (!$ || typeof $.ajaxTransport !== 'function' || typeof window.fetch !== 'function' || typeof window.FormData !== 'function') return;

  var SECAO = 'ng-gaveta';
  var VALIDADE_MS = 1500;
  var CARRINHO = /\/cart\/(add|change|update|clear)(\.js|\.json)?$/;
  var GRAPHQL = /\/api\/(\d{4}-\d{2}|unstable)\/graphql\.json$/;
  var guardado = null;    // { carrinho: texto JSON, html: texto, em: ms, usouCarrinho, usouHtml }
  var desenhando = false; // true só enquanto o tema desenha a gaveta guardada
  var geracao = 0;        // sobe a cada mudança de carrinho enviada
  var emVoo = 0;          // mudanças de carrinho enviadas que ainda não responderam

  function descartar() {
    guardado = null;
  }

  function mudou() {
    geracao++;
    guardado = null;
  }

  function valido() {
    if (!guardado) return false;
    var vencido = Date.now() - guardado.em > VALIDADE_MS;
    var gasto = guardado.usouCarrinho && guardado.usouHtml && !desenhando;
    if (vencido || gasto) {
      guardado = null;
      return false;
    }
    return true;
  }

  function endereco(url) {
    if (!url) return null;
    try { return new URL(String(url), location.href); } catch (e) { return null; }
  }

  function urlDe(entrada) {
    if (typeof entrada === 'string') return entrada;
    if (entrada && typeof entrada.href === 'string') return entrada.href; // objeto URL
    if (entrada && typeof entrada.url === 'string') return entrada.url;   // objeto Request
    return '';
  }

  // Muda o carrinho? (corpo só é conhecido no fetch; no XHR o GraphQL é conferido no send)
  function ehMudanca(metodo, u, corpo) {
    if (!u || u.origin !== location.origin) return false;
    if (/^(\/[a-z]{2}(-[a-z]{2})?)?\/discount\//i.test(u.pathname)) return true;
    if (metodo !== 'POST') return false;
    if (CARRINHO.test(u.pathname)) return true;
    if (GRAPHQL.test(u.pathname)) return typeof corpo !== 'string' || /\bmutation\b/.test(corpo);
    return false;
  }

  // Raiz do idioma da página ('' no idioma principal), a mesma que o tema usa na gaveta.
  function raiz() {
    var r = (window.routes && typeof window.routes.root === 'string') ? window.routes.root : '';
    return r.replace(/\/+$/, '');
  }

  // A gaveta vai abrir depois do add? (configuração do tema: carrinho rápido em gaveta lateral)
  function gavetaVaiAbrir() {
    if (document.body && document.body.classList.contains('template-cart')) return false;
    var depois = window.after_add_to_cart, rapido = window.quick_cart;
    if (!depois || depois.type !== 'quick_cart') return false;
    if (!rapido || !rapido.show || rapido.type === 'popup') return false;
    return true;
  }

  function separar(bruto) {
    var json = /<script type="application\/json" data-ng-carrinho>([\s\S]*?)<\/script>/.exec(bruto);
    if (!json) return null;
    var carrinho = JSON.parse(json[1]);
    if (!carrinho || !Array.isArray(carrinho.items)) return null;
    // A Section Rendering API embrulha a seção em <div id="shopify-section-ng-gaveta" …>.
    var envelope = /^\s*<div\b[^>]*\bid="shopify-section-ng-gaveta"[^>]*>([\s\S]*)<\/div>\s*$/.exec(bruto.replace(json[0], ''));
    if (!envelope) return null;
    return { carrinho: json[1], html: envelope[1] };
  }

  function guardar(resposta) {
    try {
      var bruto = resposta && resposta.sections && resposta.sections[SECAO];
      var partes = typeof bruto === 'string' ? separar(bruto) : null;
      guardado = partes ? { carrinho: partes.carrinho, html: partes.html, em: Date.now(), usouCarrinho: false, usouHtml: false } : null;
    } catch (e) {
      guardado = null;
    }
  }

  // Cópia das opções do fetch com sections no FormData, ou null se este POST não deve pedir a gaveta.
  function opcoesComSecao(entrada, opcoes, u) {
    var corpo = opcoes && opcoes.body;
    if (typeof entrada !== 'string' || !/\/cart\/add\.js$/.test(u.pathname) || !gavetaVaiAbrir()) return null;
    if (!(corpo instanceof window.FormData) || corpo.has('sections') || corpo.has('sections_url')) return null;
    var lote = false;
    corpo.forEach(function (valor, nome) { if (/^items\[/.test(nome)) lote = true; });
    if (lote) return null;
    var copia = new window.FormData();
    corpo.forEach(function (valor, nome) { copia.append(nome, valor); });
    copia.append('sections', SECAO);
    copia.append('sections_url', raiz() + '/cart');
    var novas = {};
    for (var k in opcoes) {
      if (Object.prototype.hasOwnProperty.call(opcoes, k)) novas[k] = opcoes[k];
    }
    novas.body = copia;
    return novas;
  }

  // 1) fetch: toda mudança de carrinho é contada; o POST do botão do produto pede a gaveta junto.
  var fetchAnterior = window.fetch;
  window.fetch = function (entrada, opcoes) {
    var alvo = this || window;
    var muda = false, novas = null;
    try {
      var metodo = String((opcoes && opcoes.method) || (entrada && entrada.method) || 'GET').toUpperCase();
      var u = endereco(urlDe(entrada));
      muda = ehMudanca(metodo, u, opcoes && opcoes.body);
      if (muda) novas = opcoesComSecao(entrada, opcoes, u);
    } catch (e) {
      muda = false;
      novas = null;
    }
    if (!muda) return fetchAnterior.apply(alvo, arguments);

    var sozinho = emVoo === 0;
    mudou();
    var minha = geracao;
    emVoo++;
    var promessa;
    try {
      // Enviado uma única vez: daqui em diante nenhum erro reenvia o POST.
      promessa = novas ? fetchAnterior.call(alvo, entrada, novas) : fetchAnterior.apply(alvo, arguments);
    } catch (e) {
      emVoo--;
      throw e;
    }
    return Promise.resolve(promessa).then(function (resposta) {
      emVoo--;
      if (!novas || !resposta || !resposta.ok) return resposta;
      var leitura;
      try { leitura = resposta.clone().json(); } catch (e) { return resposta; }
      // Nunca muda o que o tema recebe: a mesma resposta, com ou sem gaveta guardada.
      return leitura.then(function (dados) {
        if (sozinho && minha === geracao) guardar(dados); else descartar();
      }, descartar).then(function () { return resposta; }, function () { return resposta; });
    }, function (erro) {
      emVoo--;
      throw erro;
    });
  };

  // 2) XHR (jQuery do tema e apps, ex.: brinde automático): mudança de carrinho é contada e descarta.
  if (window.XMLHttpRequest && XMLHttpRequest.prototype && typeof XMLHttpRequest.prototype.open === 'function' &&
      typeof XMLHttpRequest.prototype.send === 'function') {
    var abrirAnterior = XMLHttpRequest.prototype.open;
    var enviarAnterior = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (metodo, url) {
      try {
        var m = String(metodo || '').toUpperCase();
        var u = endereco(url);
        this.__ngMuda = !!(u && u.origin === location.origin && ehMudanca(m, u, null));
        this.__ngGraphql = !!(this.__ngMuda && GRAPHQL.test(u.pathname));
        if (this.__ngMuda) mudou();
      } catch (e) {}
      return abrirAnterior.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (corpo) {
      try {
        var conta = this.__ngMuda && !this.__ngContado;
        if (conta && this.__ngGraphql && typeof corpo === 'string' && !/\bmutation\b/.test(corpo)) conta = false;
        if (conta) {
          var xhr = this;
          xhr.__ngContado = true;
          emVoo++;
          mudou();
          xhr.addEventListener('loadend', function () { emVoo--; xhr.__ngContado = false; }, { once: true });
        }
      } catch (e) {}
      return enviarAnterior.apply(this, arguments);
    };
  }

  // 3) Responde, sem rede, as leituras do jQuery que o tema faz logo depois.
  function entrega(texto, tipo, antes, depois) {
    var timer = null;
    return {
      send: function (cabecalhos, concluir) {
        timer = setTimeout(function () {
          timer = null;
          if (antes) antes();
          try {
            concluir(200, '', { text: texto }, 'Content-Type: ' + tipo);
          } finally {
            if (depois) depois();
          }
        }, 0);
      },
      abort: function () {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      }
    };
  }

  // Só a URL exata que o tema usa: sem parâmetros além do anticache do jQuery (_) e do view da gaveta.
  function soParametros(u, aceitos) {
    var ok = true;
    u.searchParams.forEach(function (valor, nome) { if (aceitos.indexOf(nome) === -1) ok = false; });
    return ok;
  }

  $.ajaxTransport('+*', function (opcoes) {
    if (opcoes.async === false || String(opcoes.type || 'GET').toUpperCase() !== 'GET') return;
    if (!valido()) return;
    var u = endereco(opcoes.url);
    if (!u || u.origin !== location.origin) return;
    var base = raiz();

    // GET /cart.js: o do tema logo após o POST (uma vez), e os feitos enquanto a gaveta guardada
    // é desenhada (ex.: barra de frete grátis), que veem o carrinho do mesmo instante do HTML.
    if (u.pathname === base + '/cart.js' && soParametros(u, ['_'])) {
      if (desenhando) return entrega(guardado.carrinho, 'application/json; charset=utf-8');
      if (guardado.usouCarrinho) return;
      guardado.usouCarrinho = true;
      return entrega(guardado.carrinho, 'application/json; charset=utf-8');
    }

    // GET /cart?view=ajax_side_cart: o HTML da gaveta (uma vez).
    if (u.pathname === base + '/cart' && u.searchParams.get('view') === 'ajax_side_cart' &&
        soParametros(u, ['view', '_']) && !guardado.usouHtml) {
      guardado.usouHtml = true;
      return entrega(guardado.html, 'text/html; charset=utf-8',
        function () { desenhando = true; },
        function () { desenhando = false; });
    }
  });
})();
